const API_URL = process.env.REACT_APP_API_SERVER_URL ?? "";

/**
 * URL for a team's avatar image served by stats-api (`GET /teams/:id/avatar`).
 *
 * Returns `undefined` when there is no team id so callers fall back to the sport
 * icon. The endpoint 404s for teams without a stored image; the `Avatar` falls
 * back to the sport icon on that error, so no existence check is needed up front.
 */
export const teamAvatarUrl = (teamId?: string): string | undefined =>
  teamId ? `${API_URL}/teams/${teamId}/avatar` : undefined;
